import { render, staticRenderFns } from "./ThePaymentModuleOtherPaymentsPanel.vue?vue&type=template&id=2683d780&scoped=true"
import script from "./ThePaymentModuleOtherPaymentsPanel.vue?vue&type=script&lang=js"
export * from "./ThePaymentModuleOtherPaymentsPanel.vue?vue&type=script&lang=js"
import style0 from "./ThePaymentModuleOtherPaymentsPanel.vue?vue&type=style&index=0&id=2683d780&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2683d780",
  null
  
)

export default component.exports